import { Link } from 'react-router-dom';
import { resourcesGroups } from './navData';

const Group = ({ group }) => (
  <div>
    <p className="text-[#F29B3D] text-[10px] font-extrabold tracking-[2px] uppercase px-3 mb-1.5">{group.heading}</p>
    <div className="space-y-0.5">
      {group.items.map((item) => {
        const Icon = item.icon;
        return (
          <Link
            key={item.name}
            to={item.href}
            data-testid={`dropdown-res-${item.name.toLowerCase().replace(/\s+|&/g, '-').replace(/--+/g, '-')}`}
            className="flex items-start gap-3 px-3 py-2.5 rounded-lg hover:bg-white/[0.05] transition-colors duration-150 group/item"
          >
            <Icon className="w-4 h-4 text-[#F29B3D]/80 mt-0.5 shrink-0" strokeWidth={1.5} />
            <span className="min-w-0">
              <span className="block text-[13px] font-medium text-[#DCE4EE] group-hover/item:text-white leading-snug transition-colors">{item.name}</span>
              <span className="block text-[11px] text-[#94A3B8]">{item.desc}</span>
            </span>
          </Link>
        );
      })}
    </div>
  </div>
);

export const ResourcesMenu = () => (
  <div className="bg-[#120836] border border-white/10 rounded-2xl shadow-[0_30px_80px_rgba(0,0,0,0.5)] p-5 w-[600px] relative overflow-hidden" data-testid="resources-mega-panel">
    <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#F29B3D]/40 to-transparent" />
    <div className="grid grid-cols-2 gap-x-6 gap-y-5">
      <div className="space-y-5">
        <Group group={resourcesGroups[0]} />
        <Group group={resourcesGroups[2]} />
      </div>
      <div>
        <Group group={resourcesGroups[1]} />
      </div>
    </div>
  </div>
);
